import { Axios } from '../api';
import { REGISTERS_API_URL } from '../constants';
import { useRegisterConfiguration } from '../store';
import { type MappedConfigurationResponse } from '../types';

export class RegisterConfigurationService {
    async fetchAndUpdate() {
        const response = await Axios.get<MappedConfigurationResponse>(
            REGISTERS_API_URL.REGISTER.CONFIGURATION,
        );

        const registerConfigStore = useRegisterConfiguration.getState();
        registerConfigStore.update(response.data);
    }
}
